<template>
  <div class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
      <thead class="bg-gray-50 dark:bg-gray-900/50">
        <tr>
          <th
            v-for="column in columns"
            :key="column.key"
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
            {{ column.label }}
          </th>
          <th scope="col" class="relative px-6 py-3">
            <span class="sr-only">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
        <tr
          v-for="location in locations"
          :key="location.id"
          class="hover:bg-gray-50 dark:hover:bg-gray-700/30 cursor-pointer"
          @click="$emit('view', location)">
          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-primary-600 dark:text-primary-400 hover:text-primary-500">
            {{ location.name }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
            {{ location.business_name }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
            {{ location.city }}, {{ location.state }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <StatusBadge
              :verified="location.verified"
              verified-text="Verified"
              pending-text="Pending" />
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-right text-sm">
            <button
              type="button"
              class="text-primary-600 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300"
              @click="$emit('view', location)">
              View
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import StatusBadge from './status_badge.vue'

defineProps({
  locations: {
    type: Array,
    required: true,
    validator: (value) => Array.isArray(value)
  }
})

defineEmits(['view'])

const columns = [
  { key: 'name', label: 'Location' },
  { key: 'business', label: 'Business' },
  { key: 'address', label: 'Address' },
  { key: 'status', label: 'Status' }
]
</script>
